module.exports = __webpack_public_path__ + "static/srinidhi-309b57dbb54501cf5036997eb771bc13.jpg";